<script lang="ts">
    import { t } from "@lernetz/svelte-translate";
    import { Icon } from "@lernetz/svelte-icon";

    // Sprache serverseitig aus <html lang="…"> lesen – unabhängig davon,
    // ob die jeweilige Seite setupSharedProps() aufgerufen hat.
    const lang =
        typeof document !== "undefined" ? document.documentElement.lang : "de";
    const isFr = lang.startsWith("fr");

    const privacyUrl = isFr
        ? "https://www.heros-des-elements.ch/fr/protection-des-donnees/"
        : "https://www.element-hero.ch/de/datenschutz/";
    const imprintUrl = isFr
        ? "https://www.heros-des-elements.ch/fr/impressum/"
        : "https://www.element-hero.ch/de/impressum/";
    const websiteUrl = isFr ? "https://www.vkg.ch/fr" : "https://www.vkg.ch";
    const orgName = isFr
        ? "AECA Association des établissements cantonaux d’assurance"
        : "Vereinigung Kantonaler Gebäudeversicherungen (VKG)";
</script>

<footer class="w-full text-blue-main">
    <div class="max-w-1280 mx-auto px-16 md:px-24 py-16 md:py-20 text-center">
        <!-- Zeile 1: Website + rechtliche Links -->
            <div
                class="flex items-center justify-center flex-wrap gap-x-12 gap-y-4 font-bold"
            >
                <a
                    href={websiteUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    class="flex items-center gap-8 hover:text-blue-hover transition-colors"
                >
                    <span
                        class="w-24 h-24 shrink-0 rounded-full bg-blue-main flex items-center justify-center"
                    >
                        <Icon name="arrow-up-right" class="w-14 h-14" />
                    </span>
                    www.vkg.ch
                </a>
                <span class="opacity-50" aria-hidden="true">·</span>
                <a
                    href={imprintUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    class="font-normal hover:text-blue-hover hover:underline underline-offset-2 transition-colors"
                >
                    {$t("imprint")}
                </a>
                <span class="opacity-50" aria-hidden="true">·</span>
                <a
                    href={privacyUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    class="font-normal hover:text-blue-hover hover:underline underline-offset-2 transition-colors"
                >
                    {$t("privacy policy")}
                </a>
            </div>

            <!-- Zeile 2: Kontakt -->
            <address class="not-italic text-14 opacity-80 mt-6">
                {orgName}, Bundesgasse 20, 3001 Bern
            </address>
    </div>
</footer>
